// PageTracker.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', 'AW-18056889507', {
        page_path: location.pathname,
      });
    }
  }, [location]);

  return null; // no UI
};

export default PageTracker;